export default "__VITE_ASSET__wawh_a9M__"